import React, { useState, useEffect } from 'react'
import { signIntoFirebase } from '../firebase/firebase';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import styles from './signin-style.module.css';

function SignInForum({setShowNavBar}) {
    const navigation = useNavigate();

    const location = useLocation();
    const toPath = (location.state == null) ? '/home' : location.state;

    useEffect(() => setShowNavBar(false));

    const passwordEye = '/images/password-eye.png';
    const passwordEyeSlash = '/images/password-eye-slash.png';

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')    
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState(passwordEye);


    const handleSubmit = (e) => {
        e.preventDefault();

        let adjustedEmail = email;

        if(email === '') 
            adjustedEmail = document.getElementById("email").value;

        const onError = (err) => {
            console.log(err)
            console.log(err.code === 'auth/invalid-credential')

            var errText = document.getElementById(styles.error);
            errText.style.display="block";

            if(email === "" && password === "")
                errText.textContent = "Please enter your email and password."
            else if(email === "")
                errText.textContent = "Please enter your email ."
            else if( password === "")
                errText.textContent = "Please enter your password."
            else if(err.code === 'auth/invalid-credential')
                errText.textContent = "Invalid email or password."
            else if(err.code === 'auth/too-many-requests')
                errText.textContent = "To many sign attempts. Please try again later."
            else
                errText.textContent = "There was an error trying to sign you in."            
        }

        signIntoFirebase(adjustedEmail, password, navigation, toPath, onError)
    }

    const handleToggle = () => {
        if (type==='password'){
           setIcon(passwordEyeSlash);
           setType('text')
        } else {
           setIcon(passwordEye)
           setType('password')
        }
     }

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <form className={styles.form} onSubmit={handleSubmit}>
                    <div>
                        <img className={styles.icon} src="/images/logo/chautauqua-interconnect-icon.svg" alt="Chautauqua Interconnect Icon"/>
                    </div>
                    <h1>Chautauqua Interconnect</h1>
                    <label htmlFor="email" className={styles.label}>Email</label>
                    <input id="email" className={styles.field} type="email" autoComplete="email" onChange={(e) => setEmail(e.target.value)}/>

                    <label htmlFor="password" className={styles.label}>Password</label>
                    <input id="password" className={`${styles.field} ${styles.password}`} type={type} autoComplete="current-password" onChange={(e) => setPassword(e.target.value)}/>
                    <span>
                            <img className={styles.eye} alt="Veiw Password Eye" src={icon} onClick={handleToggle}/>
                    </span>
                    <div style={{marginTop: '20px'}}>
                        <button className={styles.signin_btn} type='submit'>SIGN IN</button>
                        <h3 id={styles.error}>Error Text Here</h3>
                        <div className={styles.or}>OR</div>
                        <Link id={styles.request} to='/request-account'>Request Account</Link>
                    </div>
                </form>
            </div>
        </div>        
    )
}

export default SignInForum